import { render, staticRenderFns } from "./gameOperation.vue?vue&type=template&id=2b0408c6"
import script from "./gameOperation.vue?vue&type=script&lang=js"
export * from "./gameOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports